export default __webpack_public_path__ + "static/media/_DUA6493.7affc827.jpg";